import React from "react";
import {useSelector} from "react-redux";
import {NavLink as Links, Route, Switch, useRouteMatch,} from "react-router-dom";
import Error404 from "../../../Components/Error404";
import Basic from "./Basic";
import Payment from "./Payment";
import Sms_Notification from "./Sms_Notification";

export default function Company() {
  const companyInfo = useSelector((state) => state.Auth.company);
  const { url } = useRouteMatch();
  return (
    <>
      <header
        className="header bg-img"
        data-overlay={5}
        style={{ backgroundImage: `url("${companyInfo.Logo}")` }}
      >
        <div className="header-info h-250px mb-0">
          <div className="media align-items-end">
            <img
              className="avatar avatar-xxxl avatar-bordered"
              alt={companyInfo.Name}
              src={companyInfo.Logo}
            />
            <div className="media-body">
              <h2 className="text-white">
                <strong>{companyInfo.Name}</strong>
              </h2>
              <p className="text-white">
                {`${companyInfo.Address}, ${companyInfo.Contact}`}
              </p>
            </div>
          </div>
        </div>
        <div className="header-action bg-white">
          <nav className="nav tabs-left">
            <Links className="nav-link" activeClassName="active" to={`${url}`}>
              Basic
            </Links>
            <Links
              className="nav-link"
              activeClassName="active"
              to={`${url}/SMSNotification`}
            >
              Printer
            </Links>
          </nav>
        </div>
      </header>
      <Switch>
        <Route path={url} exact component={Basic} />
        <Route path={`${url}/Payment`} exact component={Payment} />
        <Route
          path={`${url}/SMSNotification`}
          exact
          component={Sms_Notification}
        />
        <Route path="*">
          <Error404 />
        </Route>
      </Switch>
    </>
  );
}
